import {
  DELETE_EXPENSE,
  DELETE_RECEIVE,
  FETCH_CUSTOMER_DETAILS,
  INSERT_EXPENSE,
  INSERT_RECEIVE,
  UPDATE_EXPENSE,
  UPDATE_RECEIVE,
} from "../config/types";

const initialState = {
  exp_amount: 0,
  project_cost: 0,
  received_amount: 0,
  customerReceiveList: [],
  customerExpList: [],
};

const customerDetailsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CUSTOMER_DETAILS:
      return { ...state, ...payload };

    case INSERT_EXPENSE:
      const customerExpList = [payload, ...state.customerExpList];
      const exp_amount = calculateTotal(customerExpList);
      return { ...state, customerExpList, exp_amount };

    case UPDATE_EXPENSE: {
      const { amount, note, id } = payload;
      const customerExpList = state.customerExpList.map((ele) =>
        ele.id === id ? { ...ele, amount, note } : ele
      );
      const exp_amount = calculateTotal(customerExpList);
      return { ...state, customerExpList, exp_amount };
    }

    case DELETE_EXPENSE: {
      const { id } = payload;
      const customerExpList = state.customerExpList.filter(
        (ele) => ele.id !== id
      );
      const exp_amount = calculateTotal(customerExpList);
      return { ...state, customerExpList, exp_amount };
    }

    case INSERT_RECEIVE:
      const customerReceiveList = [payload, ...state.customerReceiveList];
      const received_amount = calculateTotal(customerReceiveList);
      return { ...state, customerReceiveList, received_amount };

    case UPDATE_RECEIVE: {
      const { amount, note, received_by, id } = payload;
      const customerReceiveList = state.customerReceiveList.map((ele) =>
        ele.id === id ? { ...ele, amount, note, received_by } : ele
      );
      const received_amount = calculateTotal(customerReceiveList);
      return { ...state, customerReceiveList, received_amount };
    }

    case DELETE_RECEIVE: {
      const { id } = payload;
      const customerReceiveList = state.customerReceiveList.filter(
        (ele) => ele.id !== id
      );
      const received_amount = calculateTotal(customerReceiveList);
      return { ...state, customerReceiveList, received_amount };
    }

    default:
      return state;
  }
};

const calculateTotal = (list) => {
  return list.reduce(
    (accumulator, currentValue) => accumulator + currentValue.amount,
    0
  );
};
export default customerDetailsReducer;
